import axios from '@/tools/http'
//  注册
export const postRegisterApi = (data) => {return axios.post('/register',data)} 
//  找回密码-个人
export const postupdatePasswordApi = (data) => {return axios.post('/updatePassword',data)} 
//  找回密码-企业
export const postproofPasswordApi = (data) => {return axios.post('/proofPassword',data)} 
//  密码登录
export const postLoginApi = (data) => {return axios.post('/login',data)} 
//  短信登录
export const postMobileLoginApi = (data) => {return axios.post('/mobileLogin',data)} 
//  退出登录
export const getOutLoginApi = (data) => {return axios.get('/outLogin',{params:data})} 
//  获取登录验证码
export const getVerifyApi = (data) => {return axios.get('/verify',{params:data})} 
//  获取手机验证码
export const getsendSmsApi = (data) => {return axios.get('/sendSms',{params:data})} 
//  获取用户信息
export const getUserInfoApi = (data) => {return axios.get('/getUserInfo',{params:data})} 
//  获取中介信息
export const getuserSettleApi = (data) => {return axios.get('/userSettle',{params:data})} 
//  中介机构注册
export const postuserSettleApi = (data) => {return axios.post('/userSettle',data)} 
//  中介机构>添加业绩信息
export const getUserGongShangApi = (data) => {return axios.get('/getUserGongShang', {params: data})}
//  中介机构>获取公司信息
export const postcreateCompanyApi = (data) => {return axios.post('/createCompany',data)} 
//  获取政策法规
export const getpolicyListApi = (data) => {return axios.get('/policyList',{params:data})} 
//  获取中介超市简介,我要进驻
export const getmessageListApi = (data) => {return axios.get('/messageList',{params:data})} 
//  获取行政审批部门列表
export const getcreateMessageApi = (data) => {return axios.get('/createMessage',{params:data})} 
//  提交咨询,建议,投诉举报,社会评议
export const postcreateMessageApi = (data) => {return axios.post('/createMessage',data)} 
//  获取咨询,建议,投诉举报,社会评议公示列表
export const getmessageApi = (data) => {return axios.get('/message',{params:data})} 
//  获取日常监管
export const getdailyListApi = (data) => {return axios.get('/dailyList',{params:data})} 
// 获取城市列表
export const getCityListApi = (data) => {return axios.get('/cityList', {params: data})} 
// 获取首页公告
export const getBulletinListApi = (data) => {return axios.get('/bulletinList', {params: data})} 
// 首页轮播图
export const getHomeAdListApi = (data) => {return axios.get('/homeAdList', {params: data})} 
// 公告详情  
export const getBulletinInfoApi = (data) => {return axios.get('/bulletinInfo', {params: data})} 
// 首页 第一个轮播图 serverData
export const getServerDataApi = (data) => {return axios.get('/serverData', {params: data})} 
// 首页轮播图公告详情  
export const gethomeAdInfoApi = (data) => {return axios.get('/homeAdInfo', {params: data})} 
// 竞价直播列表
export const getuserQuoteListApi = (data) => {return axios.get('/userQuoteList', {params: data})} 
// 竞价结果
export const getquoteListApi = (data) => {return axios.get('/quoteList', {params: data})} 
// 服务详情 serverInfo
export const getServerInfoApi = (data) => {return axios.get('/serverInfo', {params: data})} 
// 采购公告 -- 首页
export const getDemandDataApi = (data) => {return axios.get('/demandData', {params: data})} 
// 采购公告详情 -- 首页
export const getDemandInfoApi = (data) => {return axios.get('/demandInfo', {params: data})} 
// 中介机构--首页
export const getUserDataApi = (data) => {return axios.get('/userData', {params: data})} 
// 服务类型分类
export const getCateTypeApi = (data) => {return axios.get('/cateType', {params: data})} 
// 点击首页中介机构进入详情
export const getHomeUserInfoApi = (data) => {return axios.get('/homeUserInfo', {params: data})} 
// 企业资格信息 -- 首页
export const getUserProofApi = (data) => {return axios.get('/userProof', {params: data})} 
// 服务事项搜索表单 -- serve
export const getServerTypeApi = (data) => {return axios.get('/serverType', {params: data})} 
// 服务事项列表 -- serve
export const getserveListApi = (data) => {return axios.get('/serverList', {params: data})} 
// 中介机构类型 -- intermediary
export const getUserTypeApi = (data) => {return axios.get('/userType', {params: data})} 
// 中介机构列表 -- intermediary
export const getUserListApi = (data) => {return axios.get('/userList', {params: data})} 
// 采购公告分类
export const getServeTitleApi = (data) => {return axios.get('/getServeTitle', {params: data})} 
// 采购公告列表
export const getDemandListApi = (data) => {return axios.get('/demandList', {params: data})} 
// 采购公告>我要报名
export const createOrderApi = (data) => {return axios.post('/createOrder',data)} 
// 选取公示列表
export const getorderMiddleListApi = (data) => {return axios.get('/orderMiddleList', {params: data})} 
// 选取公示详情
export const getorderMiddleInfoApi = (data) => {return axios.get('/orderMiddleInfo', {params: data})} 
// 获取OSS 参数
export const getOssDataApi = () => {return axios.post('getOssPolicy/temp')} 
// 获取通知公告列表
export const getBullListApi = (data) => {return axios.get('/bullList', {params: data})} 
// 首首页头部统计
export const getTotalDataApi= (data) => {return axios.get('/totalData',{params:data})}
// 资质列表
export const getUserProofListApi= (data) => {return axios.get('/userProofList',{params:data})}
// 合同管理
export const getorderContractListApi= (data) => {return axios.get('/orderContractList',{params:data})}
// 合同管理>合同范本
export const getcontractTemplateApi= (data) => {return axios.get('/contractTemplate',{params:data})}
// 信用公式 信用评价
export const getCreditListApi= (data) => {return axios.get('/creditList',{params:data})}
// 信用公式 不良记录
export const getHarmfulListApi= (data) => {return axios.get('/harmfulList',{params:data})}
// 信用公式 黑名单
export const getBlackListApi= (data) => {return axios.get('/blackList',{params:data})}
// 信用公示>所有服务
export const getuserServeListApi= (data) => {return axios.get('/userServeList',{params:data})}
// 信用公示>所有服务>服务详情
export const getuserServerInfoApi = (data) => {return axios.get('/userServerInfo', {params: data})}
// 信用公示>中选记录
export const getuserMiddleApi = (data) => {return axios.get('/userMiddle', {params: data})}
// 信用公示>服务指南
export const getuserGuideApi = (data) => {return axios.get('/userGuide', {params: data})}
// 信用公示>职业/执业人员信息
export const getuserPracticeApi = (data) => {return axios.get('/userPractice', {params: data})}
// 

// 

//     get
// 外部使用  import { getCityListApi } from '@/apis/index.js'
// const {data:rse} = await getCityListApi(params)